import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ServicesMarketingCardsData } from "../../data/marketing-material.data";
import { MarketingCard } from "../marketing-card/marketing-card.model";

@Component({
  selector: "common-services-section-lp",
  templateUrl: "./services-section-lp.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicesSectionLpComponent implements OnInit {
  marketingCards: MarketingCard[] = ServicesMarketingCardsData;

  constructor() {}

  ngOnInit(): void {}
}
